import React from "react";
import {Form, FormGroup, Input} from "reactstrap";
import FromValidationError from "./FormValidationError";


function ForgottenPasswordForm(props) {
    return (
            <Form id="forgottenPasswordForm" data-testid="forgottenPasswordForm">
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="forgottenPasswordForm.input.email"
                        type="email"
                        validations={['required', 'email']}
                        name="email"
                        value={props.email}
                        onChange={props.handleChange}
                        id="email"
                        placeholder="Enter your email"
                    />
                    <FromValidationError field={props.validationErrors.email}/>
                </FormGroup>
                <div><p className={'error'} data-testid="forgottenPasswordForm.error">{props.error}</p></div>
                <div className={"auth-form-buttons gap-top-4"}>
                    { props.resetClickable ?
                        <button className="try-pi-btn auth-form-button-left"
                                 data-testid="forgottenPasswordForm.button.resetPassword"
                                 onClick={props.forgottenPassword}>RESET
                        PASSWORD</button>
                        :
                        <button disabled={true} className="try-pi-btn auth-form-button-left-errors"
                                 data-testid="forgottenPasswordForm.button.resetPassword.disabled">RESET PASSWORD</button>
                    }
                    <button className="try-pi-btn auth-form-button-right short-text"
                            data-testid="forgottenPasswordForm.button.back" onClick={props.resetState}>BACK</button>
                </div>
            </Form>

        );
}
export default ForgottenPasswordForm